exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bk-asiacity-tavolos-widget{position:relative;padding:0;width:100%;margin:0 auto 30px}#bk-asiacity-tavolos-widget .book-with-bk{text-align:center;height:54px}#bk-asiacity-tavolos-widget .book-with-bk-logo{background:#fff;padding:0 15px;display:inline-block}#bk-asiacity-tavolos-widget .book-with-bk-logo span{display:inline-block;font-size:24px;font-weight:700;vertical-align:middle}#bk-asiacity-tavolos-widget .book-with-bk-logo img{position:relative;display:block;background:#fff;height:32px!important;width:auto!important;margin-left:10px}#bk-asiacity-tavolos-widget hr.book-with-bk-line{margin:0;margin-top:-18px;border:0;border-top:1px solid #000}@media (max-width:767px){#bk-asiacity-tavolos-widget{padding:0 15px;width:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-418124fe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BKAsiaCity.vue
// module id = 55
// module chunks = 0